import styled, { css } from "styled-components";

export const SidebarOverlay = styled.div`
  @media only screen and (min-width: 992px) {
    display: none !important;
  }
`;

export const SidebarWrapper = styled.aside`
  z-index: 100;
  width: 260px;
  position: fixed;
  ${({ theme }) => theme.start}: -260px;
  background: ${({ theme }) => theme.bg};
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  box-shadow: rgba(82, 63, 105, 0.22) 0px 0px 30px 0px;
  padding: 0.5rem 1rem;
  transition: 0.5s;

  @media only screen and (min-width: 992px) {
    ${({ theme }) => theme.start}: 0;
    width: 260px;
  }

  &.active {
    ${({ theme }) => theme.start}: 0;
  }

  .sidebar-links {
    .chakra-accordion {
      .chakra-accordion__item {
        .chakra-accordion__button {
          display: block;
          padding: 0.8rem 1rem;
          position: relative;
          border-radius: 8px;
          color: ${({ theme }) => theme.light};
          margin-bottom: 0.5rem;

          &:hover {
            background: none;
          }

          .icon {
            color: ${({ theme }) => theme.primary};
            font-size: 19px;
            margin-top: -4px;
          }

          .text {
            color: ${({ theme }) => theme.secondary};
            margin: 0 1rem;
            text-transform: capitalize;
            font-weight: 600;
            font-size: 0.8rem;
          }

          .collapse-icon {
            transition: 0.3s;
            ${({ theme }) =>
              theme.start === "right" &&
              css`
                transform: rotate(180deg);
              `}
          }

          &[aria-expanded="true"],
          &.active {
            background: ${({ theme }) => theme.primary};
            .icon,
            .collapse-icon,
            .text {
              color: ${({ theme }) => theme.light};
            }
            .collapse-icon {
              transform: rotate(90deg);
            }
          }
        }

        .chakra-collapse {
          ul {
            list-style: none;
            margin-bottom: 1rem;
            margin-inline-start: 1rem;

            li {
              margin-bottom: 0.5rem;

              &:last-child {
                margin-bottom: 0;
              }

              /* Apply same style for <a> and our action button */
              a,
              button.sidebar-linklike {
                display: flex;
                align-items: center;
                width: 100%;
                background: transparent;
                border: 0;
                padding: 0;
                text-align: left;
                cursor: pointer;

                &.active {
                  span {
                    color: ${({ theme }) => theme.secColor};
                  }
                }

                svg {
                  margin-top: -4px;
                  color: ${({ theme }) => theme.secColor};
                  font-size: 13px;
                  ${({ theme }) =>
                    theme.start === "right" &&
                    css`
                      transform: rotate(180deg);
                    `}
                }

                span {
                  color: ${({ theme }) => theme.newSecondary1};
                  padding: 0 0.3rem;
                  text-transform: capitalize;
                  font-size: 12px;
                  font-weight: 600;
                }

                &:hover {
                  text-decoration: none;
                  background: none;
                }
              }
            }
          }
        }
      }
    }
  }
`;
